<app-topbar-mobile />
@if (Hidebar()) {
<div class="site-header inline sticky top-0 z-5">
  <div
    class="mobile-header__panel"
    style="padding-top: 8px; padding-bottom: 8px"
  >
    <div class="container">
      <div class="mobile-header__body">
        <button
          name="menu"
          class="mobile-header__menu-button"
          style="margin-top: 4.5px"
          (click)="menuCategorias.open(null, null)"
        >
          <i
            class="fa-regular fa-bars hamburguesa"
            style="font-size: 17px"
          ></i>
        </button>
        <!-- Start::logo implementos -->
        <a class="mobile-header__logo me-auto" [routerLink]="['/', 'inicio']">
          <img
            height="35"
            [src]="logoSrc"
            alt="logo-implementos"
            title="logo-implementos"
            class="lazyload"
          />
        </a>
        <!-- End::logo implementos -->
        <div class="mobile-header__indicators" style="justify-content: end">
          <!-- Start::carro de compras -->
          <div
            class="indicator indicator--mobile"
            style="
              margin-left: -8%;
              width: 55px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <a
              [routerLink]="['/', 'carro-compra']"
              class="indicator__button"
              style="flex-direction: column; padding-bottom: 0"
            >
              <div
                style="
                  height: 30px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <i class="fa-light fa-cart-shopping fa-xl lg:text-lg">
                  @if (cart.quantity$ | async) {
                  <span>
                    <span
                      pBadge
                      class="fa-xs"
                      [value]="cart.quantity$ | async | filter"
                      severity="danger"
                    ></span>
                  </span>
                  }
                </i>
              </div>
              <div
                style="
                  height: 16px;
                  display: flex;
                  justify-content: center;
                  align-items: start;
                "
              >
                <span
                  style="
                    line-height: normal;
                    text-align: center;
                    font-size: 10px;
                  "
                  >Carro</span
                >
              </div>
            </a>
          </div>
          <!-- End::carro de compras -->
          <!-- Ingreso cuenta usuario -->
          <app-mobile-header-account />
        </div>
      </div>
    </div>
  </div>
  <div class="mobile-header__panel" style="padding-bottom: 15px">
    <div class="container">
      <div class="mobile-header__body">
        <!-- BARRA DE BUSCADOR -->
        <app-mobile-search style="margin-top: 8px; width: 100%" />
      </div>
    </div>
  </div>
</div>
}
<div class="bottomBar p-0 m-0 w-100"></div>
